import React, {useState, useEffect, useContext, useCallback} from 'react';
import moment from 'moment';
import axios from 'axios';
import Qs from 'qs';

import Conf from 'utils/Conf';
import Context from 'utils/Context';
import SuspenseSpinner from 'components/SuspenseSpinner';
import {useVimeoDuration} from 'hooks';

import VirtualRoom from './VirtualRoom';

const VirtualRoomContainer = ({params}) => {
  const [seanceFull, setSeanceFull] = useState(null);
  const {appState} = useContext(Context);
  const [startAt, setStartAt] = useState(0);

  // const filmDuration = useVimeoDuration(seance.film_id);
  const [ok1, cinemaJingleDuration] = useVimeoDuration(seanceFull && seanceFull.jingle_id);
  const [ok2, globalTrailerDuration] = useVimeoDuration(seanceFull && seanceFull.bande_annonce_admin);
  const [ok3, seanceTrailerDuration] = useVimeoDuration(seanceFull && seanceFull.intro_id);

  const obtainAWSAuthCookie = useCallback(
    (mediaVideoPath, cb) => {
      if (!seanceFull) return;
      // get signed cookie from our api to sign all video segements requests
      axios
        .get(`${Conf.apiBaseUriLegacy}/get_media_auth_cookies`, {
          params: {
            hash: params.hash,
            uuid: appState.uuid,
            seance_id: seanceFull.seance_id,
            media_video_path: mediaVideoPath,
          },
          withCredentials: true,
        })
        .then(() => {
          cb();
        });
    },
    [seanceFull, params.hash, appState.uuid],
  );

  // EVENT HANDLERS EFFECT
  useEffect(() => {
    const exit = () => {
      if (navigator.sendBeacon) {
        const queryString = Qs.stringify({
          state: 0, // 0 means leaving
          uuid: appState.uuid,
          email: appState.user ? appState.user.email : '',
        });
        navigator.sendBeacon(`${Conf.apiBaseUriLegacy}/presence_tick/${params.id}?${queryString}`);
      }
    };

    window.addEventListener('unload', exit, false);
    return () => {
      window.removeEventListener('unload', exit);
    };
  }, [appState.uuid, appState.user, params.id]);

  // DATA FETCHING EFFECT
  useEffect(() => {
    const fetchSeanceFull = () => {
      axios
        .get(`${Conf.apiBaseUriLegacy}/seance/${params.id}/full`, {
          params: {
            hash: params.hash,
            uuid: appState.uuid,
          },
          withCredentials: true,
        })
        .then(res => {
          if (res.data.authorized) {
            setStartAt(res.data.time + Date.now());
            setSeanceFull(res.data.seance);
          }
        });
    };
    fetchSeanceFull();
  }, [params.id, params.hash, appState.uuid]);

  // PRESENCE PING EFFECT
  useEffect(() => {
    let timeout;
    const presenceTick = (presence = true) => {
      let email = '';
      try {
        email = appState.user.email;
      } catch (error) {}
      axios
        .post(
          `${Conf.apiBaseUriLegacy}/presence_tick/${params.id}`,
          Qs.stringify({
            state: presence ? 1 : 0,
            uuid: appState.uuid,
            email,
          }),
          {
            withCredentials: true,
          },
        )
        .then(() => {
          timeout = setTimeout(presenceTick, 5000);
        });
    };
    presenceTick();
    return () => {
      if (timeout) clearTimeout(timeout);
      presenceTick(false);
    };
  }, [params.id, appState.uuid, appState.user.email]);

  if (!seanceFull || !ok1 || !ok2 || !ok3) {
    return <SuspenseSpinner />;
  }

  const tzStartTime = moment.tz(seanceFull.start_time, seanceFull.zone_name).format();

  const seance = {
    ...seanceFull,
    tzStartTime,
    startAt,
    // filmDuration: 886,
    cinemaJingleDuration,
    globalTrailerDuration,
    seanceTrailerDuration,
  };

  return <VirtualRoom seance={seance} obtainAWSAuthCookie={obtainAWSAuthCookie} />;
};

export default VirtualRoomContainer;
